<template>
  <div class="block-brands">
    <div class="l-grid">
      <div class="block-brands__content-top">
        <div class="block-brands__select-title">
          {{ $t('actions.brandsSelect') }}
        </div>
        <div class="block-brands__select">
          <input-select-native
            id="brands"
            v-model="selectedBrand"
            :class="{ '-has-value': selectedBrand }"
            :placeholder="$t('forms.placeholder.select')"
            name="brands"
            :options="items"
            sync />
        </div>
      </div>
      <div class="block-brands__content">
        <div
          v-if="brand"
          class="block-brands__brand-title">
          {{ brand.title }}
        </div>
        <div
          v-if="brand"
          :class="['block-brands__brand', `-cols-${brand.description2 && brand.websiteUrl ? '4' : brand.description2 || brand.websiteUrl ? '3' : '2'}`]">
          <div class="block-brands__brand-logo">
            <base-image
              v-if="exists(brand.logo)"
              v-bind="getFirst(brand.logo)" />
          </div>
          <div
            v-if="brand.websiteUrl"
            class="block-brands__brand-url">
            <a
              :href="brand.websiteUrl.url"
              target="_blank"
              rel="noopener noreferrer">{{ brand.websiteUrl.url.replace(/^https?:\/\//i, '').replace(/\/$/, '') }}</a>
          </div>
          <div
            class="block-brands__brand-description"
            v-html="brand.description" />
          <div
            class="block-brands__brand-description"
            v-html="brand.description2" />
          <div
            v-if="download"
            class="block-brands__brand-document">
            <cta
              variant="text"
              :text="download.title ?? $t('actions.discover')"
              :href="download.src">
              {{ download.title ?? $t("actions.discover") }}
            </cta>
          </div>
        </div>
      </div>

      <!--
      <div class="block-brands__content-top">
        <div
          v-if="brand"
          class="block-brands__content-desc">
          <base-button
            :label="$t('general.reservedarea_link_request')"
            mode="secondary-outlined"
            class="the-notifications__action"
            @click="modal = true">
            {{ $t('general.reservedarea_link_request') }}
          </base-button>
        </div>
      </div>
      -->
    </div>

    <teleport to="body">
      <base-modal
        :show="modal"
        @close="modal = false">
        <template #default>
          <form-builder
            v-if="modal"
            :id="`aftersales-form-reservedArea`"
            class="block-brands__form"
            handle="afterSalesSupport"
            :params="[{ key: 'request', value: 'whiteGoods' }]"
            @submitted="modal = false" />
        </template>
      </base-modal>
    </teleport>
  </div>
</template>

<script setup>
  import { BRANDS } from '~/graphql/pages/listing'

  const { bus } = useNuxtApp()
  const { locale } = useI18n()
  const props = defineProps({
    brands: {
      type: Array,
      default: []
    }
  })

  const items = ref(props.brands)
  const selectedBrand = ref(null)
  const modal = ref(false)

  if (!exists(props.brands)) {
    const { data, error } = await useAsyncData(
      `brands-${locale.value}`,
      () => useApi(BRANDS), {
        transform: r => (r.brands)
      })

    items.value = data.value
  }

  const brand = computed(() => {
    if (!exists(items.value) || !selectedBrand.value) return
    return items.value.find(i => i.id === selectedBrand.value)
  })
  const download = computed(() => {
    if (!brand.value) return
    return exists(brand?.value?.download) ? getFirst(brand?.value?.download) : null
  })

  watch(() => selectedBrand.value, async () => {
    await nextTick()
    bus.emit('scroll:refresh')
  }, { immediate: true })
</script>

<style lang="scss" scoped>
.block-brands {
  @include blocks-y-spacing;

  &__content {
    grid-column: 1 / span 12;

    @include mq(medium) {
      grid-column: 2 / span 10;
    }
  }

  &__content-top {
    grid-column: 1 / span 12;

    @include mq(medium) {
      grid-column: 4 / span 6;
    }
  }

  &__select-title {
    margin-bottom: rem(40px);
  }

  &__select .input-select.-has-value {
    margin-bottom: rem(80px);
  }

  &__brand {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: rem(24px);

    @include mq(medium) {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: var(--grid-gutter);

      &.-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }

      &.-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }
    }
  }

  &__brand-title {
    font-weight: 600px;
    color: var(--color-red);
    grid-column: 1  /span 4;
    margin-bottom: rem(16px);
  }

  &__brand-logo {
    max-width: rem(300px);
    background-color: var(--color-white);
    padding: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__content-desc {
    font-size: 1.125rem;
    padding: 2rem 0;
    margin: 0 auto;
    justify-self: center;
  }

  &__form :deep(.form-loader__field .cta[type="submit"]) {
    background-color: var(--color-red);
  }

  &__form :deep(.form-loader__field.-col-4),
  &__form :deep(.form-loader__field.-col-6) {
    @include mq(medium) {
      grid-column: 1 / span 12;
    }
  }

  &__brand-description {
    overflow: hidden;
  }

  &__brand-description a,
  &__brand-url a {
    text-decoration: underline;
  }
}
</style>
